import { Scatter, mixins } from 'vue-chartjs'

export default {
    extends: Scatter,
    mixins: [mixins.reactiveProp],
    props: ['options', 'chartData'],
    mounted() {
        // this.addPlugin({
        //     afterDatasetsDraw: function(chartInstance, easing) {
        //         // To only draw at the end of animation, check for easing === 1
        //         var ctx = chartInstance.chart.ctx;
        //
        //         chartInstance.data.datasets.forEach(function (dataset, i) {
        //             var meta = chartInstance.getDatasetMeta(i);
        //             if (!meta.hidden) {
        //                 meta.data.forEach(function(element, index) {
        //                     // Draw the text in black, with the specified font
        //                     ctx.fillStyle = 'rgb(0, 0, 0)';
        //
        //                     var fontSize = 14;
        //                     var fontStyle = 'normal';
        //                     var fontFamily = 'Helvetica Neue';
        //                     ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
        //
        //                     // Just naively convert to string for now
        //                     var dataString = dataset.data[index].toString();
        //
        //                     // Make sure alignment settings are correct
        //                     ctx.textAlign = 'center';
        //                     ctx.textBaseline = 'middle';
        //
        //                     var padding = 5;
        //                     var position = element.tooltipPosition();
        //                     ctx.fillText(dataString, position.x, position.y - (fontSize / 2) - padding);
        //                 });
        //             }
        //         });
        //     }
        // });
        this.renderChart(this.chartData, this.options)
    },
    watch: {
        chartData(){
            console.log('updating chart');
            this.$data._chart.update();
        }
    }
}
